import { mutatorAction } from 'satcheljs';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';

export const setTypeOfItemBeingDragged = mutatorAction(
    'setTypeOfItemBeingDragged',
    function setTypeOfItemBeingDragged(dataItemType: string) {
        getFullComposeViewState().typeOfItemBeingDragged = dataItemType;
    }
);

export const setShowDropHint = mutatorAction('setShowDropHint', (shouldShow: boolean) => {
    getFullComposeViewState().showDropHint = shouldShow;
});
